import { Link } from 'react-router-dom';
import PageMeta from '../../components/SEO/PageMeta';
import styles from './NotFoundPage.module.css';

export default function NotFoundPage() {
  return (
    <>
      <PageMeta
        title="Page Not Found"
        description="The page you are looking for does not exist."
        path="/404"
      />
      <div className={styles.wrap}>
        <h1>404</h1>
        <p>This page could not be found.</p>
        <Link to="/" className={styles.link}>
          Browse all converters
        </Link>
      </div>
    </>
  );
}
